SWR.Social.prototype._getTikTokParams = function _getTikTokParams(){
  var self = this;
  var data = {};

  data.endpoint = 'https://www.tiktok.com/oembed';
  data.params = {};
  data.dataType = 'json';

  return data;
};
